import React, { useState, useEffect, useCallback } from "react";
import { FaPen, FaTrash, FaTimes } from "react-icons/fa";
import "./AdminDeductionList.css";
import Header from "../../layouts/Employee/Header";
import SubHeader from "../../layouts/Admin/SubHeader";
import AdminDeductionListLayout from "../../layouts/Admin/DeductionListLayout";
const AdminDeductionList = () => {
  return (
    <>
      <Header />
      <SubHeader />
      <AdminDeductionListLayout />
    </>
  );
};

export default AdminDeductionList;
